// USER PROFILE LIST
export const USER_PROFILE_LIST_COLUMN = "USER_PROFILE_LIST_COLUMN";
